// Template Generated by DataExtraction.py at 1716507313
        
import AchieversPlanSummaryEN1 from "../../Forms/Plan Summaries/Achievers Plan Summary-EN-1.png";
import AchieversPlanSummaryEN1Labels from "../../Labels/Plan Summaries/Achievers Plan Summary-EN-1.json";
import AchieversPlanSummaryFR1 from "../../Forms/Plan Summaries/Achievers Plan Summary-FR-1.png";
import AchieversPlanSummaryFR1Labels from "../../Labels/Plan Summaries/Achievers Plan Summary-FR-1.json";
import {
    defaultFontSize,
    drawTextOnLabel,
    fillCheckboxAtLabel,
    standardFormAlias,
    standardFormCompression,
    isLanguageEnglish,
    standardFormFormat,
    standardFormHeight,
    standardFormWidth,
    standardFormX,
    standardFormY,
    signatureLabel, 
    signatureTab
} from "../../PDFGenerationUtils";
import {POSSIBLE_SIGNERS} from "../../../Utils/PlanUtils";

import moment from "moment/moment";

/*
 * @param doc {jsPDF}
 */
const generate = (doc, data, quote, authStatus, i18n) => {

    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? AchieversPlanSummaryFR1Labels : AchieversPlanSummaryEN1Labels;
    const formImage = isFrench ? AchieversPlanSummaryFR1 : AchieversPlanSummaryEN1;

    function fillCheckbox(value, label){
        fillCheckboxAtLabel(doc, value, label, labels);
    }
    
    function drawText(value, label){
        drawTextOnLabel(doc, value, label, labels);
    }

    // add image
    doc.addImage(formImage, standardFormFormat, labels["image"]["x"], labels["image"]["y"], labels["image"]["width"], labels["image"]["height"], null, standardFormCompression);

    /* define state variables here ie:
     * const subscriber = data.subscriber;
     * const jointSubscriber = data.jointSubscriber;
     * const beneficiary = data.beneficiary;
    */

    // Drawing the form
}

//Returns the signature definitions for the document
// This includes who needs to sign and where
const signatureDefinitions = (state, documentId, pageNumber, i18n) => {
    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? AchieversPlanSummaryFR1Labels : AchieversPlanSummaryEN1Labels;
    const DRRecipientId = POSSIBLE_SIGNERS['Dealing Representative'];
    const subscriberRecipientId = POSSIBLE_SIGNERS['Subscriber'];
    const jointSubscriberRecipientId = POSSIBLE_SIGNERS['Joint Subscriber'];
    let signers = [];
    let signHereTabs = [];
    
    
    
    return signers;
}

export default {
    generate,
    signatureDefinitions
}
    